<template>
    <div class="steps-outer-container" v-if="!myAccountInBacklink">
        <div class="steps-container">
            <div class="steps-content">
                <div class="steps-list row">
                    <a :href="$ceres.urls.basket" rel="nofollow" :title="$translate('modeherz::CheckoutClient.checkoutStepsGoToBasket')" class="position-relative step-basket">
                        <div class="step-entry is-active">
                            <div class="position-relative step-entry-text-wrapper">
                                <span class="d-none d-sm-inline-block">1.</span>
                                <span class="step-entry-text">{{ $translate('modeherz::CheckoutClient.checkoutStepsBasket') }}</span>
                            </div>
                            <div class="arrow-right is-active"/>
                        </div>
                    </a>
                    <a  @click="handleLoginClick" :href="$ceres.urls.checkout" rel="nofollow" :title="$translate('modeherz::CheckoutClient.checkoutStepsGoToLogin')" class="position-relative step-login">
                        <div class="step-entry"  :class="{'is-active': isLogin || isCheckout}">
                            <div class="arrow-right-left"/>
                            <div class="position-relative">
                                <span class="d-none d-sm-inline-block">2.</span>
                                <span class="step-entry-text">{{ $translate('modeherz::CheckoutClient.checkoutStepsLogin') }}</span>
                            </div>
                            <div class="arrow-right" :class="{'is-active': isLogin || isCheckout}"/>
                        </div>
                    </a>
                    <div class="step-entry step-checkout position-relative"  :class="{'is-active': isCheckout}">
                        <div class="arrow-right-left"/>
                        <div class="position-relative">
                            <span class="d-none d-sm-inline-block">3.</span>
                            <span class="step-entry-text">{{ $translate('modeherz::CheckoutClient.checkoutStepsCheckout') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CheckoutSteps',
        props:{
            stepType:{
                type: String,
                required: true
            },
            backlink:{
                type: String,
                default: ''
            }
        },
        computed:{
            isBasket(){
                return this.stepType === 'basket'
            },
            isLogin(){
                return this.stepType === 'login'
            },
            isCheckout(){
                return this.stepType === 'checkout'
            },
            myAccountInBacklink()
            {
                return this.backlink.includes(App.urls.myAccount);
            }
        },
        methods:{
            handleLoginClick(ev){
                if(this.isCheckout){
                    document.getElementById('open-login-modal')?.click()
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        }
    };
</script>

<style scoped>

</style>
